/**
 * @expFlag public-app-download-banner
 * @ticket CLOUDWEB-20131
 * @file
 */
import { Button, Text } from '@vkontakte/vkui';
import { ReactComponent as CloudLogo } from 'img/cloud_blue_new.svg';
import { ReactComponent as Star } from 'img/icons/star_10.svg';
import { ReactComponent as StarHalf } from 'img/icons/star_half_10.svg';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPublicItemType } from 'reactApp/modules/public/public.helpers';
import { getCurrentPublicItem } from 'reactApp/modules/public/public.selectors';
import { CancelIcon } from 'reactApp/ui/VKUIIcons';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import styles from './MobileAppBanner.css';

interface MobileAppBannerProps {
    href: string;
    text?: string;
}

export const MobileAppBanner = memo(({ href }: MobileAppBannerProps) => {
    const publicItem = useSelector(getCurrentPublicItem);
    const deepLink = `?mt_deeplink=${window.location.href}`;
    const [isVisible, setIsVisible] = useState(true);

    const handleOnMobileAppClick = useCallback(() => {
        sendDwh({
            eventCategory: ECategoryGa.publicActionToInstall,
            action: 'click-download',
            dwhData: {
                type_public: publicItem ? getPublicItemType(publicItem) : undefined,
                type_element: 'banner',
            },
        });

        setTimeout(() => {
            window.location.href = href + deepLink;
        }, 100);
    }, [publicItem, deepLink, href]);

    const handleClose = useCallback(() => {
        sendDwh({
            eventCategory: ECategoryGa.publicActionToInstall,
            action: 'close',
            dwhData: {
                type_public: publicItem ? getPublicItemType(publicItem) : undefined,
                type_element: 'banner',
            },
        });
        setIsVisible(false);
    }, [publicItem]);

    useEffect(() => {
        sendDwh({
            eventCategory: ECategoryGa.publicActionToInstall,
            action: 'show',
            dwhData: {
                type_public: publicItem ? getPublicItemType(publicItem) : undefined,
                type_element: 'banner',
            },
        });
    }, []);

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles.banner}>
            <div className={styles.left}>
                <CloudLogo height={30} width={30} />
                <div className={styles.content}>
                    <Text className={styles.text}>Приложение Облака</Text>
                    <div className={styles.rate}>
                        <div className={styles.stars}>
                            <Star />
                            <Star />
                            <Star />
                            <Star />
                            <StarHalf />
                        </div>
                        <Text className={styles.rateText}>386K</Text>
                    </div>
                </div>
            </div>
            <div className={styles.right}>
                <Button size="s" mode="primary" appearance="accent" onClick={handleOnMobileAppClick} className={styles.button}>
                    Установить
                </Button>
                <CancelIcon onClick={handleClose} className={styles.close} />
            </div>
        </div>
    );
});

MobileAppBanner.displayName = 'MobileAppBanner';
